import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import { UPDATE_CUSTOMER } from "../customer.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateCustomerInput } from "../../../__generated__/globalTypes";
import {
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables,
} from "../../../__generated__/UpdateCustomerMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateCustomer = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateCustomerInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UPDATE_CUSTOMER, {
    refetchQueries: ["CustomersQuery", "CustomerQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateCustomer?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateCustomer?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
